export default __webpack_public_path__ + "0675f975964586562dabae85629ea895.svg";